import React from "react";
import Progress from "react-progressbar";

const calcPercentage = (
    getAssessmentNumberCount,
    getAssessmentCompletedCount
) => {
   
    const calculate =
        (getAssessmentCompletedCount / getAssessmentNumberCount) * 100;
    return (
        <span
            style={{
                margin: "0.5em 0 0 0",
                color: "#bab9a8",
                fontSize: "13px",
                display: "flex",
            }}
        >
            <div
                style={{
                    width: "6em",
                    height: "0.8em",
                    margin: "0 0.5em 0 0",
                    border: "solid 1px #aaa",
                }}
            >
                <Progress completed={calculate} color="#1a5985" />
            </div>
            <div style={{marginTop:'-4px'}}>{calculate.toFixed(1)}%</div>
        </span>
    );
};

export { calcPercentage }


// WEBPACK FOOTER //
// ./src/new/Utils/calculate-progress.js